import { api } from '../../api/apiClient';
import { WorkoutHistoryItem, WorkoutHistoryResponse } from './types';

export const fetchWorkoutHistory = async (
  userId: string,
  search: string = '',
  page: number = 1,
  limit: number = 10
): Promise<WorkoutHistoryItem[]> => {
  try {
    const response = await api<WorkoutHistoryResponse>({
      endpoint: `/users/admin/workoutHistory/${userId}?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`,
      method: 'GET',
    });

    return response?.data?.list || [];
  } catch (error) {
    console.error('Error fetching workout history:', error);
    return [];
  }
};
